import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminCosmeticStatus } from '@web/shared/module/cosmetic';
import { AdminCosmeticStatusPipe } from '../../pipes/admin-cosmetic-status.pipe';

@Component({
  selector: 'app-admin-cosmetic-status',
  imports: [CommonModule, AdminCosmeticStatusPipe],
  templateUrl: './admin-cosmetic-status.component.html',
  styleUrl: './admin-cosmetic-status.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminCosmeticStatusComponent {
  public readonly status = input.required<AdminCosmeticStatus>();
}
